export const dateTypes = [
  {
    label: "指定日期",
    value: "Custom"
  },
  {
    label: "当前日期",
    value: "TODAY"
  }
]

export const timeTypes = [
  {
    label: "指定时间",
    value: "Custom"
  },
  {
    label: "系统当前时间",
    value: "NOW"
  }
]

export const needDelSpaceList = [
  "sn",
  "text",
  "card",
  "mail",
  "telephone",
  "money_cn",
  "rich",
  "url"
]

export const dateFormat = [
  { label: "年", value: "年", djFormat: "YYYY" },
  { label: "年月", value: "年月", djFormat: "YYYY-MM" },
  { label: "年月日", value: "年月日", djFormat: "YYYY-MM-DD" },
  { label: "年月日时", value: "年月日时", djFormat: "YYYY-MM-DD HH" },
  { label: "年月日时分", value: "年月日时分", djFormat: "YYYY-MM-DD HH:mm" },
  { label: "年月日时分秒", value: "年月日时分秒", djFormat: "YYYY-MM-DD HH:mm:ss" }
]

export const dateKeys = [
  {
    key: "years",
    unit: "year"
  },
  {
    key: "months",
    unit: "month"
  },
  {
    key: "days",
    unit: "day"
  },
  {
    key: "hours",
    unit: "hour"
  },
  {
    key: "minutes",
    unit: "minute"
  },
  {
    key: "seconds",
    unit: "second"
  }
]
